import { render, staticRenderFns } from "./DynamicPriceList.vue?vue&type=template&id=f380b6fe&scoped=true&"
import script from "./DynamicPriceList.vue?vue&type=script&lang=js&"
export * from "./DynamicPriceList.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPriceList.vue?vue&type=style&index=0&id=f380b6fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f380b6fe",
  null
  
)

export default component.exports